/**
 * @fileoverview JkbtneditComponent - 按鈕編輯元件
 * @description
 * 此元件提供帶有開窗按鈕的編輯欄位功能，用於選擇和顯示關聯資料。
 * 可以通過彈出視窗從資料表中選取值，並自動填入對應的顯示名稱和值。
 *
 * @author JK Team
 * @version 1.0.0
 */
import {
  Component,
  Input,
  OnInit,
  output,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { entityState, JkfieldlabelComponent } from 'jk-service';
import { AgOpenwinComponent, } from '../agopenwin/agopenwin.component';
import { jkLib } from 'jk-service';
import { jkRestReturnClass } from 'jk-service';
import { JkOpenwinParams, jkRestReturn } from 'jk-service';
import { JkBaseComponent } from 'jk-service';
import { MaterialModule } from 'jk-service';

/**
 * @component JkbtneditComponent
 * @description
 * 提供帶有開窗按鈕的編輯欄位功能，可開啟視窗選擇關聯資料。
 * 適用於需要從參考資料表中選取值的場景，如選擇客戶、產品等。
 * @extends {JkBaseComponent}
 */
@Component({
  selector: 'app-jkbtnedit',
  templateUrl: './jkbtnedit.component.html',
  styleUrls: ['./jkbtnedit.component.scss'],
  standalone: true,
  providers: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MaterialModule,
    CommonModule,
    NgStyle,
    FormsModule,
    //HttpClientModule,
    JkfieldlabelComponent,
    MatIcon,
  ],

})
export class JkbtneditComponent extends JkBaseComponent implements OnInit {
  _state: entityState = entityState.dsBrowse;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set state(st: entityState) {
    this._state = st;
  }
  _keyfield: boolean = false;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set keyfield(st: boolean) {
    this._keyfield = st;
    if (this._keyfield) {
      this.readonly.set(true);
    } else {
      this.readonly.set(false);
    }
  }
  /**
   * @property {string} comType - 元件類型
   * @override
   */
  override comType: string = 'jkbtnedit';
  //@ViewChild('openwin')  openwin: JkopenwinComponent;
  //selectbox: DxSelectBoxComponent;
  //@Input() matAutocomplete!: MatAutocomplete;
  /**
   * @property {Object} flexStyle - 彈性佈局樣式
   * @override
   */
  override flexStyle: any = { display: 'flex', flexDirection: 'column' };
  /**
   * @property {string} valueExpr - 值表達式，指定值欄位名稱
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() valueExpr: string = 'id';
  /**
   * @property {string} displayExpr - 顯示表達式，指定顯示名稱欄位名稱
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() displayExpr: string = 'name';
  /**
   * @property {boolean} showName - 是否顯示名稱
   */
  readonly showName = input<boolean>(true);
  /**
   * @property {string} displayName - 顯示名稱
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() displayName: string = '';
  //@Input()  width: number = 200;
  /**
   * @property {string} maintable - 主表名稱
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() maintable: string = '';
  /**
   * @property {string} item - 項目名稱
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() item: string = '';
  //@Input() isMultiSelect: boolean = false;
  /**
   * @property {Array<any>} params - 參數陣列
   */
  readonly params = input<Array<any>>([]);
  /**
   * @property {number} height - 高度
   */
  readonly height = input<number>(200);
  /**
   * @property {boolean} showCloseButton - 是否顯示關閉按鈕
   */
  readonly showCloseButton = input<boolean>(true);

  /**
   * @property {boolean} showOpenWinButton - 是否顯示開窗按鈕
   */
  readonly showOpenWinButton = input<boolean>(true);
  /**
   * @property {any} _value - 內部值
   */
  _value: any; // string = '';
  /**
   * @property {any} value - 元件值
   */
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get value(): any {
    return this._value;
  }
  set value(v: any) {
    if (this._value !== v) {
      this._value = v;
      this.valueChange.emit(this._value);
    }
  }
  /**
   * @event valueChange - 值變更事件
   */
  readonly valueChange = output<any>();

  readonly valueBlur = output<string>();
  onValueBlur(): void {
    this.valueBlur.emit(this.value);
  }

  // @Input() buttonText: string = '...';
  //@Output() onButtonClick = new EventEmitter<any>();
  //@Output() onValidate = new EventEmitter<any>();

  /**
   * @property {boolean} buttonVisible - 按鈕可見性
   */
  readonly buttonVisible = input<boolean>(true);
  //constructor(private ref: ChangeDetectorRef) {  }
  /**
   * @method ngOnInit
   * @description 初始化元件
   * @override
   */
  override ngOnInit() {
    super.ngOnInit();
  }
  /**
   * @method doClearClick
   * @description 清除按鈕點擊處理
   * @param {Event} $event - 事件資料
   */
  doClearClick($event: Event) {
    this.value = '';
    this.displayName = '';
  }
  /**
   * @method doOpenWinClick
   * @description 開窗按鈕點擊處理
   * @param {any} $event - 事件資料
   */
  async doOpenWinClick($event: any) {
    if (this.valueExpr === '') {
      alert('程式設計師 請設定 valueExpr');
    }

    let param: JkOpenwinParams = {
      isModal: true,
      maintable: this.maintable,
      item: this.item,
      params: this.params(),
      isMultiSelect: false,
      filterVisible: true,
      valueExpr: this.valueExpr,
      displayExpr: this.displayExpr,
      returnData: [],
    };
    let ret: jkRestReturn = new jkRestReturnClass();
    ret.obj = param;
    //let dialog = this.injector.get(MatDialog);
    //const dialogRef = dialog.open(JkopenwinComponent,{data:param} ); // ,{width:300,height:300}
    let conf = this.page.initConfig_component(param);//(orm.page as BasePage)

    //const dialogRef = dialog.open(AgOpenwinComponent, { data: param }); // ,{width:300,height:300}

    //dialogRef.afterClosed().subscribe((result) => {
    this.page.dialog.open(AgOpenwinComponent, conf) //###
      .afterClosed()
      .subscribe((result: any) => {
        if (!result) return;
        if (result.result) {
          //alert('openwin 回傳:'+JSON.stringify(data.returnData));
          try {
            let item = result.obj.returnData[0];
            if (item) {
              this.displayName = item[this.displayExpr];
              this.value = item[this.valueExpr];
              // The `value` setter will emit the `valueChange` event.

              this.cdr.markForCheck();
            }
          } catch (error: any) { }
        }
      });

  }
  /**
   * @method addWhere
   * @description 添加條件子句到 SQL WHERE 條件
   * @param {string} where - 現有 WHERE 條件
   * @param {string} fieldName - 欄位名稱
   * @param {string} condition - 條件運算符，預設為 '='
   * @returns {string} 更新後的 WHERE 條件
   */
  addWhere(where: string, fieldName: string, condition: string = '='): string {
    if (this.required() && this.value === '') {
      let msg = this.label() + ' 不可空白.';
      alert(msg);
      throw new Error(msg);
    }
    if (this.value) {
      //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
      where = jkLib.text2Where(this.value, where, fieldName, condition);
    }
    return where;
  }
}
